import React, { useState, useEffect, useRef } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MultiSelect } from 'react-multi-select-component'
import { KTSVG } from 'src/_metronic/helpers'
import { getRoleFlagList } from 'src/api/modules/master-data/master_2'
import { InputFile, InputFileRef } from 'src/app/components/InputFile'
import { handleDownloadBase64 } from 'src/app/helpers/file'
import { PopoverText } from 'src/components'
import dateformat from 'src/utils/dateformat'
import swal from 'sweetalert'

type Props = {
    show: boolean
    setShow: (value: boolean) => void
    allFiles: any[]
    addFile: (data: any) => void
    removeFile: (index: number) => void
}

const Attachment: React.FC<Props> = ({
    show,
    setShow,
    allFiles,
    addFile,
    removeFile
}) => {
    const {t} = useTranslation()
    const inputFileRef = useRef<InputFileRef>(null)

    const [namaFile, setNamaFile] = useState("")
    const [files, setFiles] = useState<any>(null)
    const [description, setDescription] = useState("")
    const [isPrivate, setIsPrivate] = useState(false)
    const [fullRole, setFullRole] = useState<any[]>([])
    const [tempRole, setTempRole] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(false)

    const handleShowRoleName = (role: any) => {
        return role.map((item: any) => item.label).join(', ')
    }

    const handleUpload = () => {

      // validation
      if (!namaFile ) return swal({
        title: [
          t('file'),
          t('must-be-filled'),
        ].join(" "),
        icon: 'error',
      })
      if (!description ) return swal({
        title: [
          t('Description'),
          t('must-be-filled'),
        ].join(" "),
        icon: 'error',
      })
      if (isPrivate && tempRole.length == 0 ) return swal({
        title: [
          t('Akses Role'),
          t('must-be-filled'),
        ].join(" "),
        icon: 'error',
      })

      addFile({
        file_name: namaFile,
        file: files,
        description: description,
        private: isPrivate,
        roles: tempRole,
        updated_at: new Date(),
        user: {
          name: localStorage.getItem('username')
        },
        is_base64: true
      })

      setNamaFile("")
      setFiles([])
      setDescription("")
      setIsPrivate(false)
      setTempRole([])

      inputFileRef?.current?.reset();
    }

    const handleDelete = (index: number) => {
      swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Ya')}`],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          removeFile(index);
        }
      });
    }

    useEffect(() => {
      const getAllRoleList = async () => {
        const res = await getRoleFlagList()
        setFullRole(res.data.data)
      }

      getAllRoleList()
    }, [])

    return <>
        <Modal
        size='lg'
        show={show}
        onHide={() => setShow(false)}
        backdrop='static'
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('order-fileBox')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '170px'}}>
                    <h6>{t('order-fileUnggah')} <span className='text-danger'>*</span></h6>
                  </td>
                  <td style={{width: '70%'}}>
                      <InputFile
                          setFileName={setNamaFile}
                          setFiles={setFiles}
                          ref={inputFileRef}
                      />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '170px'}}>
                    <h6>{t('order-keterangan')} <span className='text-danger'>*</span></h6>
                  </td>
                  <td style={{width: '70%'}}>
                    <Form.Control
                      type='text'
                      value={description}
                      placeholder={t('order-keterangan')}
                      id='uploadketerangan'
                      onChange={(e: any) => setDescription(e.target.value)}
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3'>
                <tr>
                  <td style={{width: '170px'}}>
                    <h6 className='me-11'>{t('Private')}</h6>
                  </td>
                  <td style={{width: '70%'}}>
                    <Form.Check
                      reverse
                      name='isPrivate'
                      type='checkbox'
                      checked={isPrivate}
                      className='mb-4'
                      onClick={() => {
                        setIsPrivate(!isPrivate)
                      }}
                      id='isPrivate'
                    />
                  </td>
                </tr>
              </table>
              <table className='mb-3' hidden={isPrivate ? false : true}>
                <tr>
                  <td style={{width: '170px'}}>
                    <h6>{t('Akses Role')}</h6>
                  </td>
                  <td style={{width: '70%'}}>
                    <MultiSelect
                      key={isPrivate.toString()}
                      options={fullRole?.map((item: any) => {
                        return {label: item.label, value: item.value}
                      })}
                      value={tempRole}
                      onChange={(e: any) => setTempRole(e)}
                      labelledBy='Select'
                    />
                  </td>
                </tr>
              </table>
              <Button
                variant='primary'
                className='w-100'
                disabled={isLoading}
                onClick={() => handleUpload()}
              >
                {isLoading ? (
                  <Spinner animation='border' variant='light' size='sm' />
                ) : (
                  t('order-kirim')
                )}
              </Button>
            </Col>
            <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className=''>
                    <th className='text-center'>{t('order-noo')}</th>
                    <th className='text-center'>{t('order-keterangan')}</th>
                    <th className='text-center'>{t('order-tglUpload')}</th>
                    {/* <th className='text-center'>{t('User Code')}</th> */}
                    <th className='text-center'>{t('order-user')}</th>
                    <th className='text-center'>{t('Akses Role')}</th>
                    <th className='text-center'>{t('order-aksi')}</th>
                  </tr>
                </thead>
                {allFiles.length == 0 && <>
                   <tbody>
                    <td colSpan={6} className='p-4 text-center'>{ [
                      t('order-tambah'),
                      t('file'),
                    ].join(" ")}</td>
                   </tbody>
                </>}
                {allFiles.map((data: any, _index: any) => (
                  <tbody key={data?.id ?? _index}>
                    <tr className=''>
                      <td className='text-center'>
                        <label>{_index + 1}</label>
                      </td>
                      <td className='text-center'>
                        <label>{data.description}</label>
                      </td>
                      <td className='text-center'>
                        <label>{dateformat(data.updated_at)}</label>
                      </td>
                      {/* <td className='text-center'>
                        <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                      </td> */}
                      <td className='text-center'>
                        {data.user?.customer != null ? (
                          <label>{data.user?.customer?.name}</label>
                        ) : (
                          <label>{data.user?.name}</label>
                        )}
                      </td>
                      <td className='text-center'>
                        {data.private ? (
                          data.roles.length > 0 ? (
                            <PopoverText
                              content={handleShowRoleName(data.roles)}
                              index={_index}
                              className='desc-slice'
                            />
                          ) : (
                            'Private'
                          )
                        ) : (
                          'Public'
                        )}
                      </td>
                      <td className='text-center'>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          data-bs-trigger='hover'
                          title={t('unduh')}
                          onClick={() =>
                            handleDownloadBase64(data.file)
                          }
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrow-down-square-fill.svg'
                            className='svg-icon-3'
                          />
                        </button>
                        <button
                        onClick={() => handleDelete(_index)}
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Hapus')}
                        >
                        <KTSVG
                            path='/media/icons/duotune/trash-fill.svg'
                            className='svg-icon-3'
                        />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Row>
        </Modal.Body>
        </Modal>
    </>
}

export default Attachment